<template>
    <b-overlay :show='showLoader'>
        <b-card class="regular-billing mb-0">
            <h1 class="text-secondary font">{{pageName}}</h1>
            <b-row class="mt-2" align-v="center">
                <b-col cols="12" xl="4" class="mt-1">
                    <b-form-group label="Datum:" label-cols-lg="4" label-cols-md="3" label-cols-sm="3">
                        <b-input-group>
                            <flat-pickr class="form-control" v-model="date" :config="flatpickrConfig" placeholder="Datum" @input="loadData"/>
                            <b-input-group-append>
                                <button class="append-button" data-toggle><FeatherIcon icon="ChevronDownIcon"/></button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="d-flex flex-column custom-table" :style="{'gap': '8rem'}">
                <template v-if="distributorsData && distributorsData.length > 0">
                    <div v-for="(data, idx) of distributorsData" :key="`${data.sklic}_${idx}`">
                        <DistributorBasicInfo v-if="data && data.razdelilnik" class="mt-1" :data="data" />
                        <div v-if="data && data.enote && data.enote.length > 0" class="d-flex flex-wrap justify-content-end mt-1" :style="{'gap': '0.75rem'}">
                            <rounded-button v-if="data.prikazi_eracun" variant="light" @click="showPDF(data.sklic)">
                                Prikaži eRačun
                            </rounded-button>
                            <rounded-button @click="downloadZipFakture(data.sklic)">
                                Prenesi fakture
                            </rounded-button>
                        </div>
                        <template v-if="data && data.enote && data.enote.length > 0">
                            <div class="d-flex flex-column mt-2" :style="{'gap': '8rem'}">
                                <div v-for="unit of data.enote" :key="`unit_${unit.enota_sifra}`">
                                    <DistributorUnitBasicInfo :unit="unit" />
                                    <MainTable class="mt-2" :data="unit" :reference="data.razdelilnik.sklic" :date="date" />
                                </div>
                            </div>
                        </template>
                        <RecapitulationOfVATTable v-if="data && data.rekapitulacija_ddv && data.rekapitulacija_ddv.stroski && data.rekapitulacija_ddv.stroski.length > 0" class="mt-3" :data="data" />
                        <ForPaymentTable v-if="data" class="mt-3" :data="data.za_placilo" />
                    </div>
                </template>
                <h2 v-else class="text-center py-4">Ni podatkov za prikaz</h2>
            </div>
        </b-card>

        <BModal :visible="showPDFDialog" size="lg" :scrollable="false" hide-footer @cancel="hideDialog" @hidden="hideDialog" @close="hideDialog">
            <div>
                <h3 style="font-weight: bold;">eRačun</h3>
            </div>
            <div>
                <div class="d-flex justify-content-end mb-2">
                    <rounded-button @click="downloadPDF(referenceNumber)">
                        Prenesi eRačun
                    </rounded-button>
                </div>
                <div style="max-height: 70vh; overflow-y: scroll;">
                    <pdf
                        v-for="i in numPages"
                        :key="i"
                        :src="pdfSrc"
                        :page="i"
                        style="height: 100%"
                    ></pdf>
                </div>
            </div>
        </BModal>
    </b-overlay>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'
    import 'flatpickr/dist/plugins/monthSelect/style.css'
    import {Slovenian} from 'flatpickr/dist/l10n/sl.js'
    import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
    import {BRow, BCol, BFormGroup, BInputGroup, BInputGroupAppend, BCard, BOverlay, BModal} from 'bootstrap-vue'
    import RoundedButton from '@/views/Components/RoundedButton.vue'
    import DistributorBasicInfo from '@/views/Pages/MyPortal/regularBillingComponents/DistributorBasicInfo.vue'
    import MainTable from '@/views/Pages/MyPortal/regularBillingComponents/MainTable.vue'
    import RecapitulationOfVATTable from '@/views/Pages/MyPortal/regularBillingComponents/RecapitulationOfVATTable.vue'
    import ForPaymentTable from '@/views/Pages/MyPortal/regularBillingComponents/ForPaymentTable.vue'
    import DistributorUnitBasicInfo from '@/views/Pages/MyPortal/regularBillingComponents/DistributorUnitBasicInfo.vue'
    import {downloadAttachment} from '@/libs/helpers'
    import pdf from 'vue-pdf'

    export default {
        components: {
            pdf,
            BModal,
            DistributorUnitBasicInfo,
            ForPaymentTable,
            RecapitulationOfVATTable,
            MainTable,
            DistributorBasicInfo,
            BCard,
            flatPickr,
            BRow,
            BCol,
            BFormGroup,
            BInputGroup,
            BInputGroupAppend,
            RoundedButton,
            BOverlay
        },
        props: {
            distributorType: {
                type: String,
                default: '0'
            }
        },
        data() {
            return {
                date: new Date(),
                flatpickrConfig: {
                    plugins: [
                        monthSelectPlugin({
                            shorthand: true, // Enable month select plugin
                            altFormat: 'Y-m',
                            dateFormat: 'Y-m'
                        })
                    ],
                    defaultDate:'today',
                    altInput: true,
                    altFormat: 'Y-m',
                    dateFormat: 'Y-m',
                    wrap: false,
                    disableMobile: true,
                    locale: Slovenian
                },
                distributorsData: [],
                getLastDistributor: true,
                customSetDate: false,
                showPDFDialog: false,
                referenceNumber: '',
                showLoader: false,
                numPages: undefined,
                pdfSrc: ''
            }
        },
        methods: {
            async loadData(changedDate = '') {
                const date = this.dayjs(this.date).format('YYYY-MM')

                let filterDate = date
                if (changedDate.length > 0) filterDate = changedDate

                if (this.customSetDate) {
                    this.customSetDate = false
                    return
                }

                try {
                    this.showLoader = true

                    const response = await this.$http.get(`/api/iiportal-user/v2/distributor/table/${this.distributorType}/${filterDate}?get_last=${this.getLastDistributor}`)

                    this.distributorsData = response.data ?? []

                    if (this.getLastDistributor) {
                        this.getLastDistributor = false
                        if (this.distributorsData && this.distributorsData.length > 0 && this.distributorsData[0].obracun_leto && this.distributorsData[0].obracun_mesec) {
                            this.customSetDate = true
                            this.date = `${this.distributorsData[0].obracun_leto}-${this.distributorsData[0].obracun_mesec}`
                        }
                    }

                } catch (error) {
                    this.$printError('Pri nalaganju podatkov je prišlo do napake!')
                } finally {
                    this.showLoader = false
                }
            },
            hideDialog() {
                this.showPDFDialog = false
            },
            async showPDF(sklic) {
                try {
                    this.showLoader = true

                    this.pdfSrc = pdf.createLoadingTask(`/api/iiportal-user/v2/attachements/pdf/imdocs/${sklic}?from_table_view=true`)
                    const response = await this.pdfSrc.promise
                    this.numPages = response.numPages
                    this.referenceNumber = sklic
                    this.showPDFDialog = true
                } catch (error) {
                    this.$printError('Ni dokumenta za prenos')
                } finally {
                    this.showLoader = false
                }
            },
            async downloadPDF(sklic) {
                this.showLoader = true
                await downloadAttachment(this, `/api/iiportal-user/v2/attachements/pdf/imdocs/${sklic}?from_table_view=true`, `eRacun_${this.date}.pdf`)
                this.showLoader = false
            },
            async downloadZipFakture(sklic) {
                this.showLoader = true
                await downloadAttachment(this, `/api/iiportal-user/v2/attachements/distributor_table/${sklic}`, `Fakture_dobaviteljev_${this.date}.zip`)
                this.showLoader = false
            }
        },
        computed: {
            pageName() {
                if (this.distributorType === '0') return 'Redni obračun'
                return 'Obračun rezervni sklad'
            }
        },
        async mounted() {
            await this.loadData()
        }

    }
</script>

<style scoped>
.regular-billing .append-button {
  background-color: #72a5d8;
  border: none;
  color: white
}
.regular-billing .input-group > .form-control {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  transition: border-color 0.15s ease-in-out !important;
}
</style>
